/**
 * What a test drive's view adds round the ordinary player (ADR-048): the figure, the panel, the
 * resizer's frame handler. They live exactly as long as the view is shown -- gone when another view is
 * chosen and when the view's last step ends -- so each is registered here with how to take it away, and
 * taken away once, last registered first.
 */
export class ViewExtras {
  #undo: (() => void)[] = [];

  /** Registers one more thing to take away. */
  add(undo: () => void): void {
    this.#undo.push(undo);
  }

  get size(): number {
    return this.#undo.length;
  }

  /** Takes everything away, once. A second call finds nothing left. */
  dispose(): void {
    let failure: unknown;
    let failed = false;
    for (const undo of this.#undo.splice(0).reverse()) {
      try {
        undo();
      } catch (error) {
        if (!failed) failure = error;
        failed = true;
      }
    }
    if (failed) throw failure;
  }
}

/** Where the figure stands: on the land there when the world has any, else where the view says. */
export function groundedAt(
  pos: readonly [number, number, number],
  ground?: (x: number, z: number) => number,
): [number, number, number] {
  const [x, y, z] = pos;
  return [x, ground ? ground(x, z) : y, z];
}
